import { Fragment } from "react";
import { Link } from "react-router-dom";
import Icon from "../../../components/atoms/Icon";
import Loader from "../../../components/atoms/Loader";
import StudentFilter from "../../../components/features/NewStudentFilter";
import TabsNavi from "../../../components/molecules/TabsNavi";
import Settings from "../../../helpers/Settings";
import { OperatorPrivilege } from "../../../interfaces/OperatorInterface";
import SectionInterface from "../../../interfaces/SectionInterface";
import { requiredPrivileges as privilegesRequiredAtStaysDetailsPage } from "../../SectionsSettingsStaysDetailsPage";
import { SectionStay } from "../useFetchSectionStays";
import SectionStayList from "./SectionStayList";
import styles from "./styles.scss";

interface Props {
  section: SectionInterface;
  sectionStays: SectionStay[];
  isLoading: boolean;
  privileges: OperatorPrivilege[];
}

const SectionsSettingsStays = (props: Props) => {
  return (
    <Fragment>
      <TabsNavi
        tabs={[
          {
            label: "入退室記録",
            link: "#",
            active: true,
          },
          {
            label: "入室中生徒",
            link: `/sections/${props.section.id}/settings/stays/staying_students`,
            active: false,
          },
        ]}
      />
      <div className={styles.navigation}>
        <div className={styles.filter}>
          <StudentFilter sectionId={props.section.id} />
        </div>
        {privilegesRequiredAtStaysDetailsPage.every((privilege) =>
          props.privileges.includes(privilege),
        ) && (
          <Link
            to="./details"
            className={`buiButtonBase buiButtonVariantOutline`}
          >
            <Icon name="icon-setting" className={styles.svg} />
            <span>入退室設定</span>
          </Link>
        )}
        <a
          href={Settings.BORON_ENTRY_URL}
          target="_blank"
          className={`buiButtonBase buiButtonVariantOutline ${styles.button}`}
          rel="noopener noreferrer"
        >
          <Icon name="icon-external-link" className={styles.svg} />
          <span>入退室受付画面</span>
        </a>
      </div>
      <SectionStayList
        sectionId={props.section.id}
        sectionStays={props.sectionStays}
      />
      <Loader loading={props.isLoading} />
    </Fragment>
  );
};

export default SectionsSettingsStays;
